export enum SIGNALING_STATUS {
  DISCONNECTED,
  CALLING,
  RINGING,
  CONNECTING,
  CONNECTED,
  REJECTED,
  NOT_ANSWERED,
  UNAVAILABLE,
  BUSY,
}
